module.exports = __webpack_public_path__ + "img/Picture27.bda13bf6.png";